import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useGiftCardData } from '@/modules/perseo-billing/hooks/use-gift-card-data';
import { setPaymentAvailable } from '@/modules/perseo-billing/store/slices/billing';

import { GiftCardDetails } from './gift-card-details.component';
import { InsufficientBalance } from './insufficient-balance.component';

export const AppliedGiftCard = () => {
  const dispatch = useDispatch();

  const { cartHasGiftCardPayment, canGiftCardPayTotalAmount } =
    useGiftCardData();

  const hasGiftCard = cartHasGiftCardPayment();
  const canPayTotalAmount = canGiftCardPayTotalAmount();

  useEffect(() => {
    if (hasGiftCard && canPayTotalAmount) {
      dispatch(setPaymentAvailable(true));
    }
  }, [canPayTotalAmount, dispatch, hasGiftCard]);

  return canPayTotalAmount ? <GiftCardDetails /> : <InsufficientBalance />;
};
